import MarketingPage from "../marketing-page";
import ImageSlider from "../image-slider/image-slider";
import Imdb from "./imdb";

const CaseStudy = ({ logError }) => {

    const images = [
        {
            original: "/images/case-studies/IMG20240212115941.jpg",
            width: 169
        },
        {
            original: "/images/case-studies/IMG20240226211823.jpg",
            width: 534
        },
        {
            original: "/images/case-studies/IMG20240213201616.jpg",
            width: 225
        },
    ];

    return (
        <MarketingPage logError={logError} backLink={{ url: "/case-studies", text: "Back to case studies" }}>
            <div className="case-study-name">Paul Mailath, Producer/Director/DoP/Soundie/Gaffer</div>
            <h1 className="">
                Enhancing Indie Film Production with Filmanize
            </h1>
            <img className="case-study-main-image" src="/images/case-studies/ppaulm-112f_2023-05-15-08-26-48.jpg"></img>
            <Imdb name="Paul Mailath" link="https://www.imdb.com/name/nm1796717/" />
            <div>
                <div className="case-study-intro">
                    I've been involved with the industry since film school in the 1970s (using 16mm film), and went on to train as an actor.  I've been involved with the indie film scene for decades, working on project of all scales, from small to $5 million budget. I've worked with various production management tools, including Movie Magic, Gorilla, Yamdu, and StudioBinder.
                </div>
                <h4>What made you decide to try Fimanize?</h4>
                I found Filmanize whilst browsing online forums, around the time that they were looking for Beta testers to try it out. I'd been working in IT alongside my film projects and thought that the chance to combine tech and filmmaking sounded interesting, so I decided to try out Filmanize.
                <h4>How did you use it?</h4>
                Since discovering Filmanize, I've successfully used it for three projects: one short film, one music video, and one feature film. On the most recent project I started as a gaffer but ended up as 1st Assistant Director due to the lack of personnel in that specific role, covering tasks such as creating call sheets and managing most of the 1st AD duties. The project, a scripted drama, was intended to be a 22-day shoot but required 3 additional pickup days due to script issues.
                I've always enjoyed the cooperative aspect of filmmaking, and I've found that starting projects with Filmanize as early as possible in pre-production enhances the collaborative process. To get the most from Filmanize's capabilities and foster effective teamwork, it's crucial for the team to integrate Filmanize from the start of the project. Filmanize's exceptional customer service has been a real asset in navigating any problems that arose, thanks to their timely and responsive support.
                <h4>How did Filmanize help?</h4>
                Filmanize has proven to be an indispensable tool, offering significant time savings—days, in fact—particularly through its AI-driven script breakdown features. This has aligned seamlessly with my working methods, complementing my organizational style. I've found it gives a far more organised approach to managing film production that's more efficient than traditional methods.
                <h4>What would you say are the benefits of using Filmanize?</h4>
                <p>I'd sum up the benefit of Filmanize by saying that it provides a structure to effortlessly develop any film project. For filmmakers wrestling with production workflows, my advice is simple: ditch the Word documents and spreadsheets and use a tool like Filmanize that's designed for the demands of modern film production.</p>

            </div>
            <div className="image-container mt-1">
                <ImageSlider images={images} />
            </div>
        </MarketingPage>
    );
}

export default CaseStudy;